module.exports = __webpack_public_path__ + "static/img/hb_2-min.b6abea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_2-min.png
// module id = M/YV
// module chunks = 1